<template>
  <footer class="py-3 sm:py-10" style="background-color: rgb(245, 245, 247); color: #333;">
    <div class="edge-padding">
      <div class="container-custom">
      <div class="grid grid-cols-2 md:grid-cols-4 gap-x-2 gap-y-3 md:gap-y-8 md:gap-8">
        <!-- Company Info (from CMS site config) -->
        <div class="pr-4 sm:pr-0">
          <h3 class="text-sm mb-1 sm:mb-2 font-light text-gray-800">{{ siteConfig.company_name }}</h3>
          <p class="text-gray-600 mb-1 sm:mb-2 font-light text-xs leading-loose sm:leading-relaxed">{{ siteConfig.tagline }}</p>
        </div>

        <!-- Dynamic footer sections from CMS (Quick Links, Support, etc.) -->
        <div v-for="section in footerSections" :key="section.title">
          <h3 class="text-sm mb-1 sm:mb-2 font-light text-gray-800">{{ section.title }}</h3>
          <ul class="space-y-0.5 sm:space-y-1">
            <li v-for="link in section.links" :key="link.label">
              <a :href="link.url" class="text-gray-600 hover:text-gray-900 font-light text-xs leading-loose sm:leading-normal">{{ link.label }}</a>
            </li>
          </ul>
        </div>

        <!-- Contact (from CMS site config) -->
        <div>
          <h3 class="text-sm mb-1 sm:mb-2 font-light text-gray-800">Contact Us</h3>
          <ul class="space-y-0.5 sm:space-y-1">
            <li><span class="text-gray-600 font-light text-xs leading-loose sm:leading-normal">{{ siteConfig.address }}</span></li>
            <li><span class="text-gray-600 font-light text-xs leading-loose sm:leading-normal">{{ siteConfig.email }}</span></li>
            <li><span class="text-gray-600 font-light text-xs leading-loose sm:leading-normal">{{ siteConfig.phone }} ({{ siteConfig.phone_label }})</span></li>
          </ul>

          <!-- Social Media Icons -->
          <div class="flex space-x-4 mt-2 sm:mt-6">
            <a :href="siteConfig.facebook_url" class="text-gray-700 hover:text-black" aria-label="Facebook">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z" />
              </svg>
            </a>
            <a :href="siteConfig.twitter_url" class="text-gray-700 hover:text-black" aria-label="Twitter">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z" />
              </svg>
            </a>
            <a :href="siteConfig.instagram_url" class="text-gray-700 hover:text-black" aria-label="Instagram">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
              </svg>
            </a>
          </div>
        </div>
      </div>
      
      <!-- Language, Currency and Country Selector -->
      <div class="border-t border-gray-400 mt-3 pt-2 pb-1 sm:mt-6 sm:pt-4 sm:pb-4 flex flex-col sm:flex-row justify-between items-center">
        <div class="flex items-center justify-between w-full sm:justify-start sm:w-auto mb-3 sm:mb-0">
          <!-- Country Flag -->
          <div class="relative inline-block mr-4">
            <div class="w-6 h-6 rounded-full overflow-hidden flex items-center justify-center border border-gray-300 cursor-pointer" :title="countryName">
              <img :src="`https://flagcdn.com/w40/${userCountry.toLowerCase()}.png`" :alt="countryName" class="w-6 h-6 object-cover" />
            </div>
          </div>
          
          <div class="flex items-center space-x-4">
            <!-- Language Selector -->
            <div class="relative inline-block">
              <select 
                v-model="userLanguage"
                class="appearance-none bg-transparent border border-gray-300 rounded-md py-1 pl-2 pr-8 text-xs text-gray-600 cursor-pointer focus:outline-none"
                @change="onLanguageChange"
              >
                <option value="en">English</option>
                <option value="es">Español</option>
                <option value="fr">Français</option>
                <option value="de">Deutsch</option>
                <option value="it">Italiano</option>
                <option value="ja">日本語</option>
              </select>
              <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-600">
                <svg class="h-3 w-3" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
                </svg>
              </div>
            </div>
            
            <!-- Currency Selector -->
            <CurrencyExchange
              v-model="currencyStore.selectedCurrency"
              :show-label="false"
              wrapper-class="relative inline-block"
            />
          </div>
        </div>
        
        <p class="  font-light text-[10px] text-gray-600 leading-loose sm:leading-normal">&copy; {{ new Date().getFullYear() }} Macumba Travel. All rights reserved.</p>
      </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { onMounted, ref, computed } from 'vue'
import { useCurrencyStore } from '@/store/currency'
import { useAuthStore } from '@/store/auth'
import CurrencyExchange from '@/components/CurrencyExchange.vue'
import { getUserCountry, getUserLanguage } from '@/services/utils/userLocation'
import { useFooter } from '@/composables/useCms'

const { footerSections, siteConfig } = useFooter()

const currencyStore = useCurrencyStore()
const authStore = useAuthStore()
const userCountry = ref('AU')
const userLanguage = ref('en')

const countryNameMap = {
  'AU': 'Australia',
  'US': 'United States',
  'GB': 'United Kingdom',
  'CO': 'Colombia',
  'FR': 'France',
  'DE': 'Germany',
  'ES': 'Spain',
  'IT': 'Italy',
  'JP': 'Japan',
  'CA': 'Canada'
}

const countryName = computed(() => countryNameMap[userCountry.value] || userCountry.value)

function onLanguageChange() {
  localStorage.setItem('language', userLanguage.value)
  console.log(`🌍 Language manually changed to: ${userLanguage.value}`)
}

onMounted(() => {
  // Initialize currency store with auth context
  currencyStore.initialize(authStore)
  
  // Get detected/profile settings
  userCountry.value = getUserCountry(authStore)
  userLanguage.value = getUserLanguage(authStore)
})
</script>
